import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB8meBocUjIz6hIFVNFlWrMe7UumOHxOUI",
  authDomain: "belge-yonetim.firebaseapp.com",
  projectId: "belge-yonetim",
  storageBucket: "belge-yonetim.appspot.com",
  messagingSenderId: "161150350586",
  appId: "1:161150350586:web:1b13aa4e7e4e8211650543",
  measurementId: "G-FCPHC97PJR"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { auth, db, storage, doc, getDoc, ref, getDownloadURL, collection, query, where, getDocs };